var _path, _path2, _path3;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconELearning(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: props.color
  }, _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.492 7.492a1 1 0 001 1H23a1 1 0 000-2H11.492a1 1 0 00-1 1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M24 28H11.492A3.496 3.496 0 018 24.507V11.729a5.47 5.47 0 003.492 1.256H24V28zm1-17.015H11.492A3.496 3.496 0 018 7.492 3.495 3.495 0 0111.492 4H21a1 1 0 000-2h-9.508A5.499 5.499 0 006 7.492v17.015A5.499 5.499 0 0011.492 30H25a1 1 0 001-1V11.985a1 1 0 00-1-1z"
  })))));
}

export default SvgIconELearning;